import { RelatedHubGrid } from "@/components/RelatedHubGrid";
import QuotableStatsStrip from "@/components/QuotableStatsStrip";
import { createFileRoute, Link } from "@tanstack/react-router";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";
import { GOV_DOCTYPES } from "@/data/government-doctypes";

const TITLE = "รับรองเอกสารราชการไทย 18 ประเภท — แปล + MFA + Apostille | NYC";
const DESC = "บริการแปลและรับรองเอกสารราชการไทย 18 ประเภท (สูติบัตร ทะเบียนสมรส ทะเบียนบ้าน ทรานสคริปต์ ปริญญาบัตร ใบขับขี่ ใบรับรองแพทย์ ฯลฯ) โดยกรมการกงสุล — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี";

export const Route = createFileRoute("/certify/government/")({
  head: () => ({
    meta: [
      { title: ctaTitle(TITLE, "/certify/government/index", "th")}, { name: "description", content: ctaDesc(DESC, "/certify/government/index", "th")},
      { property: "og:title", content: ctaTitle(TITLE, "/certify/government/index", "th")}, { property: "og:description", content: ctaDesc(DESC, "/certify/government/index", "th")},
      { property: "og:url", content: "https://nyclanguageinstitute.com/certify/government" },
    ],
    links: canonicalAndHreflang("/certify/government", "/en/certify/government"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify({ "@context":"https://schema.org","@type":"CollectionPage","@id":"https://nyclanguageinstitute.com/certify/government#collection","url":"https://nyclanguageinstitute.com/certify/government","name":"รับรองเอกสารราชการไทย 18 ประเภท","inLanguage":"th","numberOfItems":GOV_DOCTYPES.length,"provider":{"@type":"Organization","name":"NYC Language Institute","url":"https://nyclanguageinstitute.com"} }) }],
  }),
  component: () => (
    <main className="min-h-screen bg-background">
      <section className="bg-gradient-to-b from-primary/10 to-background px-4 pt-16 pb-12">
        <div className="mx-auto max-w-5xl">
          <span className="inline-block rounded-full bg-primary/15 px-3 py-1 text-xs font-bold text-primary">รับรองเอกสารราชการ · MFA · Apostille</span>
          <h1 className="mt-3 text-3xl font-extrabold sm:text-5xl">รับรองเอกสารราชการไทย 18 ประเภท</h1>
          <p className="mt-4 max-w-3xl text-lg text-muted-foreground">{DESC}</p>
        </div>
      </section>
      <section className="mx-auto max-w-5xl px-4 py-12">
        <h2 className="text-2xl font-bold">เลือกประเภทเอกสาร</h2>
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {GOV_DOCTYPES.map((d) => (
            <Link key={d.slug} to="/certify/government/$doctype" params={{ doctype: d.slug }}
              className="rounded border p-4 hover:border-primary">
              <div className="font-semibold">{d.th}</div>
              <div className="text-xs text-muted-foreground mt-1">{d.en}</div>
              <div className="text-xs mt-2">
                <span className="text-primary font-semibold">฿{(d.translatePrice + d.mfaFee).toLocaleString()}</span> · {d.turnaround}
              </div>
              <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{d.usage}</div>
            </Link>
          ))}
        </div>
      </section>
          <QuotableStatsStrip cluster="translate" locale="th" variant="light" />
    <RelatedHubGrid locale="th" /></main>
  ),
});
